import type { ReactNode } from 'react';

export const symbol_king_bed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-494q0-25.9 17-43.95Q114-556 140-556h26v-144q0-24.75 17.63-42.38Q201.25-760 226-760h507q24.75 0 42.38 17.62Q793-724.75 793-700v144h27q24.75 0 42.38 17.62Q880-520.75 880-496v170q0 19-13.5 32.5T834-280l-17 69q-1.56 5.08-5.44 8.04Q807.67-200 803-200h-8q-4.67 0-8.56-2.96-3.88-2.96-5.44-8.04l-17-69H197l-18 69q-1.56 5.08-5.44 8.04Q169.67-200 165-200h-8q-4.67 0-8.56-2.96-3.88-2.96-5.44-8.04l-17-69q-19 0-32.5-13.5T80-326v-168Zm430-62h223v-144H510v144Zm-284 0h224v-144H226v144Zm-86 216h680v-156H140v156Zm680 0H140h680Z"
		/>
	</svg>
);
